const ARROW_SIZE = 5

/**
 * The arrowhead at a sequence's target end. Shared by committed edges and the
 * live connection preview so the two cannot drift apart.
 */
export default function SequenceArrowMarker({ id, color }: { id: string; color: string }) {
  return (
    <defs>
      <marker
        id={id}
        markerWidth={ARROW_SIZE * 2}
        markerHeight={ARROW_SIZE * 2}
        refX={ARROW_SIZE}
        refY={ARROW_SIZE}
        orient="auto-start-reverse"
        markerUnits="userSpaceOnUse"
      >
        <path
          d={`M 0 0 L ${ARROW_SIZE * 2} ${ARROW_SIZE} L 0 ${ARROW_SIZE * 2} Z`}
          fill={color}
        />
      </marker>
    </defs>
  )
}
